import http from '../../../lib/http/httpClient';
import { ShipmentTabsResponse, ShipmentAlertsResponse, ShipmentFilters, ShipmentsResponse } from '../../../types/shipment';

export const fetchShipmentTabs = async (): Promise<ShipmentTabsResponse> => {
  return http.get<ShipmentTabsResponse>('/api/v1/cp/shipments/tabs');
};

export const fetchShipmentAlerts = async (filters: ShipmentFilters): Promise<ShipmentAlertsResponse> => {
  const queryParams = new URLSearchParams();

  if (filters.status && filters.status !== 'all') {
    queryParams.append('status', filters.status);
  }
  if (filters.from_date) {
    queryParams.append('from', filters.from_date);
  }
  if (filters.to_date) {
    queryParams.append('to', filters.to_date);
  }
  if (filters.search) {
    queryParams.append('search', filters.search);
  }
  if (filters.on_hold) {
    queryParams.append('on_hold', 'true');
  }
  if (filters.division) {
    queryParams.append('division', String(filters.division));
  }

  const queryString = queryParams.toString();
  const url = `/api/v1/cp/shipments/alerts${queryString ? `?${queryString}` : ''}`;

  return http.get<ShipmentAlertsResponse>(url);
};

export const fetchShipmentList = async (params: ShipmentFilters): Promise<ShipmentsResponse> => {
  const query = new URLSearchParams();

  query.append("page", String(params.page));
  query.append("per_page", String(params.per_page));

  if (params.sort_by) query.append("sort_by", params.sort_by);
  if (params.sort_order) query.append("sort_order", params.sort_order);

  if (params.search) query.append("search", params.search);
  if (params.status) query.append("status", params.status);
  if (params.from_date) query.append("from", params.from_date);
  if (params.division !== undefined)
    query.append("division", String(params.division));

  if (params.to_date) query.append("to", params.to_date);
  if (params.arrival) query.append("arrival", params.arrival);
  if (params.trip_type) query.append("trip_type", params.trip_type);
  if (params.load_type) query.append("load_type", params.load_type);
  if (params.on_hold) query.append("on_hold", "true");
  if (params.pod) query.append("pod", "true");
  if (params.freight_invoice) query.append("freight_invoice", "true");

  return http.get<ShipmentsResponse>(
    `/api/v1/cp/shipments/list?${query.toString()}`
  );
};

export const generateShareLink = async (cnNumber: string) => {
  try {
    const response = await http.post(`/api/v1/cp/shipments/generate-share-link`, {
      cn_number: cnNumber,
    });
    return response;
  } catch (error) {
    console.error('Error generating share link:', error);
    throw error;
  }
};


export const getCnGuid = async (cnNumber: string): Promise<{ cn_guid: string }> => {
  try {
    const response = await http.get(`/api/v1/cp/shipments/get-cn-guid?cn_number=${encodeURIComponent(cnNumber)}`);
    return response;
  } catch (error) {
    console.error("Error fetching cn_guid:", error);
    throw error;
  }
};
